import React from 'react';
import PropTypes from 'prop-types';
import { isBDD } from '../utils/bdd';
import { DBQ_URL } from '../../all-claims/constants';

const bddClaimContent = (
  <>
    <p>Next, we’ll ask you to submit evidence for your claim. </p>
    <p>
      You must submit a Separation Health Assessment (self-assessment, also
      called “Part A”) with your disability compensation claim to be considered
      for the Benefits Delivery at Discharge (BDD) program.
    </p>
    <va-link
      external
      href={DBQ_URL}
      text="Find the Separation Health Assessment to download"
    />
    <p>
      <strong>
        You can also include these types of evidence to support your claim:
      </strong>
    </p>
    <ul>
      <li>Service treatment records</li>
      <li>Medical records about your conditions</li>
      <li>Supporting documents and additional forms that support your claim</li>
    </ul>
  </>
);

const standardClaimContent = (
  <>
    <p>Next, we’ll ask you to submit these types of evidence for your claim:</p>
    <ul>
      <li>
        Medical records about your conditions, <strong>and</strong>
      </li>
      <li>Supporting documents and additional forms that support your claim</li>
    </ul>
  </>
);

export const SupportingEvidenceOrientation = ({ formData }) => (
  <>
    <va-alert status="info" class="vads-u-margin-top--3">
      <h3 slot="headline">Notice of evidence needed</h3>
      <p>
        By law, section 5103, we must tell you what evidence you’ll need to
        support your claim.
      </p>
      <p>
        <va-link
          external
          href="/disability/how-to-file-claim/evidence-needed/"
          text="Learn what evidence you’ll need"
        />
      </p>
    </va-alert>
    {isBDD(formData) ? bddClaimContent : standardClaimContent}
    <p>
      <strong>Note: </strong>
      You only need to submit new evidence that we don’t already have.
    </p>
    <va-accordion open-single>
      <va-accordion-item
        bordered
        class="vads-u-margin-y--1"
        header="Where supporting documents may come from and additional forms"
        id="first"
        level="3"
      >
        <h4 className="vads-u-font-size--h5 vads-u-margin-y--0">
          Records of receiving care
        </h4>
        <ul>
          <li>Civilian physicians or caregivers</li>
          <li>Counseling facilities or health clinics</li>
          <li>Sexual trauma crisis centers or centers for domestic abuse</li>
        </ul>
        <h4 className="vads-u-font-size--h5 vads-u-margin-y--0">
          Buddy or lay statements, also called written testimonials
        </h4>
        <ul>
          <li>Family members or roommates</li>
          <li>Faculty members</li>
          <li>Fellow service members</li>
          <li>Chaplains or clergy members</li>
        </ul>
        <h4 className="vads-u-font-size--h5 vads-u-margin-y--0">
          Civilian police reports
        </h4>
        <ul>
          <li>Police headquarters</li>
          <li>Local precincts</li>
        </ul>
        <h3 className="vads-u-font-size--h5 vads-u-margin-y--0">
          Personal accounts and other correspondence
        </h3>
        <ul>
          <li>Personal journal or diary entries</li>
          <li>Emails, messages, or letters</li>
        </ul>
        <h4 className="vads-u-font-size--h5 vads-u-margin-y--0">
          Additional forms
        </h4>
        <ul>
          <li>Requests for increased compensation if you can’t work</li>
          <li>Requests for an automobile allowance</li>
          <li>
            Applications for an adaptive-equipment grant for your automobile
          </li>
        </ul>
        <p>
          <va-link
            external
            href="/disability/how-to-file-claim/additional-forms/"
            text="Learn more about the additional forms you can submit"
          />
        </p>
      </va-accordion-item>
    </va-accordion>
  </>
);

SupportingEvidenceOrientation.propTypes = {
  formData: PropTypes.object,
};
